// extracted by mini-css-extract-plugin
export default {"overlaySection":"Cover_overlaySection__DTz7+","overlay":"Cover_overlay__YCgJK","plus":"Cover_plus__To4XR"};